<template>
  <div class="cg-menu-warp">
    <a-menu
      theme="dark"
      mode="inline"
      v-model="SelectedKeys"
      :open-keys="OpenKeys"
      @click="OnClickMenu"
      @select="OnSelectMenu"
      @openChange="OnOpenChange"
    >
      <sub-menu v-for="item in dataList"
        :key="item.Name"
        :menu-info="item"
        :level="1"
        :selectedMenuKeys="value"
        :msgCountStyle="msgCountStyle"
        @subMenuClick="OnClickSubMenu"
      ></sub-menu>
    </a-menu>
  </div>
</template>
<script>
import SubMenu from "./SubMenu.vue";

export default {
  components: { SubMenu },
  name: "cg-menu",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    msgCountStyle: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      SelectedKeys: this.value,
      OpenKeys: [],
      dataMap: {},
    };
  },
  computed: {
    DataMap() {
      let _dataMap = {};

      let _dataList = this.dataList.concat([]);
      for (let _i = 0; _i < _dataList.length; _i++) {
        let _data = _dataList[_i];
        _dataMap[_data.Name] = _data;

        if (_data.Children && _data.Children.length > 0) {
          _dataList = _dataList.concat(_data.Children);
        }
      }

      return _dataMap;
    },
  },
  watch: {
    value() {
      this.SelectedKeys = this.value;
    },
    SelectedKeys() {
      this.$emit("input", this.SelectedKeys);

      let _curKey = this.SelectedKeys[0];
      let _openKeys = [];

      while (this.DataMap[_curKey] && this.DataMap[_curKey].ParentName) {
        _curKey = this.DataMap[_curKey].ParentName;

        if (_openKeys.indexOf(_curKey) < 0) {
          _openKeys.push(_curKey);
        }
      }

      this.OpenKeys = _openKeys;
    },
  },
  mounted() {},
  methods: {
    GetModuleIcon(path) {
      return CmnMis.Func.AddSiteRoot(
        path || "/Upload/cgtest.cagoe.comimage/200629/202006291142487071.png"
      );
    },
    AddSiteRoot(path) {
      return CmnMis.Func.AddSiteRoot(path);
    },
    OnSelectMenu({ item, key, selectedKeys }) {
      this.$emit("select", { item, key, selectedKeys });
    },
    OnClickMenu({ item, key, keyPath }) {
      this.$emit("click", { item, key, keyPath });
    },
    OnOpenChange(openKeys) {
      this.OpenKeys = openKeys;
    },
    OnClickSubMenu({ key, domEvent }) {
      let _selectItem = this.DataMap[key];
      while (_selectItem.Children) {
        _selectItem = _selectItem.Children[0];
      }

      if (_selectItem) {
        this.SelectedKeys = [_selectItem.Name];

        this.$emit("click", { item: _selectItem, key: _selectItem.Name });
        this.$emit("select", {
          item: _selectItem,
          key: _selectItem.Name,
          selectedKeys: this.SelectedKeys,
        });
      }
    },
  },
};
</script>
<style></style>
